<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box" style="background-color: #e2e8d7;">
        <div class="col-12 row" style="display: flex; justify-content: space-between; align-items: center;">
          <div style="flex-grow: 1; text-align: left;">
            <h4 class="form-header" style="color: black; text-align: center;"><u>Descuento para Empleados</u></h4>
          </div>
          <!-- <i class="fas fa-user-circle watermark-icon"></i> -->
        </div>
        <!-- START - Controles arriba de tabla -->
        <div class="controls-above-table">
          <div class="row col-12" style="display: flex; justify-content: space-between; align-items: center;">
            <!-- Botón alineado a la izquierda -->
            <div style="flex-shrink: 0;">
              <router-link :to="{
                path: '/cat/cupones-apl/crear',
                params: {},
              }" class="btn btn-md glow-on-hover" style="color: white;">
                Nuevo Registro &nbsp;<i class="fas fa-user-plus"></i>
              </router-link>
            </div>

            <!-- Filtros alineados a la derecha -->
            <div style="display: flex; justify-content: flex-end; align-items: center;">
              <select class="form-control form-control-sm rounded bright col-4" v-model="filter.tipo_oferta"
                @change="filterData()">
                <option value="" disabled hidden>TIPO EMPLEADO</option>
                <option value="I">INTERNO</option>
                <option value="E">EXTERNO</option>
              </select>
              <input class="form-control form-control-sm rounded bright col-5" placeholder="Nombre de Empleado"
                v-model="filter.searchtext" type="text" v-on:keyup.enter="filterData()" />
              <div class="input-group-append">
                <button class="btn btn-link btn-sm" type="button" @click="filterData()">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- END - Controles arriba de tabla -->
        <br>
        <CuponesAplTableComponent :dataTabla="dataTabla" />
      </div>
      <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="filterData" />
    </div>
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import CuponesAplTableComponent from "@/components/cat/cupones_apl/CuponesAplTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import CambiarTipoTareaModalComponent from "@/components/wms/utilidades/Asignar_tarea_usuario/CambiarTipoTareaModalComponent";

export default {
  components: {
    CuponesAplTableComponent,
    UsuariosSelectComponent,
    CategoriaSelectComponent,
    SubCategoriaSelectComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
    CambiarTipoTareaModalComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      dataTabla: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        proveedor: "",
        fecha: "",
        categoria: "",
        subcategoria: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.filterData();
  },
  methods: {
    ModalCambiarTipoTarea() {
      let self = this;
      $("#cambiarTipoTareaGlobal").modal("show");
    },
    filterData(page) {
      let self = this;
      if (!page) {
        page = 1;
      }
      self.currentPage = page;
      DynamicService.fetch("cat", "lista-precio-cupon", {
        "filter[search]": self.filter.searchtext,
        tipo_oferta: self.filter.tipo_oferta,
        page: page,
      }).then((response) => {
        self.dataTabla = response.data;
      });
    },
    clearFilterData() {
      this.$data.currentPage = 1;
      this.filter.searchtext = "";
      this.filter.tipo_oferta = "";
      DynamicService.fetch("cat", "lista-precio-cupon").then((response) => {
        this.dataTabla = response.data;
      });
    },
  },
};
</script>
<style scoped>
.element-box {
  position: relative;
}

.watermark-icon {
  position: absolute;
  top: 100%;
  left: 5%;
  transform: translate(-50%, -50%);
  font-size: 9rem;
  color: rgba(0, 0, 0, 0.08);
  z-index: 2;
  pointer-events: none;
}
</style>
